export default {
  insightUser: user,
  showNewClientDetails: false,
}



// WEBPACK FOOTER //
// ./src/Global.store.js